import { LOG } from 'src/app/common/util/log';
import { ActionFn, ActionFunctions, BoundActionFn } from './types';

export const DefaultActionsProxy = new Proxy(
  {},
  {
    get(_target, p, _receiver) {
      return (...args) => LOG.debug('Action call:', p, ...args);
    },
  }
);

export function getUniversalActionProxy(callback: ActionFn): ActionFunctions {
  return new Proxy(
    {},
    {
      get(_target, p, _receiver): BoundActionFn {
        return (...args) => callback(p.toString(), ...args);
      },
    }
  );
}
